module.exports = __webpack_public_path__ + "img/nav6h.f4af1d22.png";